// extracted by mini-css-extract-plugin
export var avatarContainer = "_9u-0";
export var avatarTypingWave = "_9u-i";
export var gray = "_9u-f";
export var green = "_9u-c";
export var icon = "_9u-9";
export var image = "_9u-1";
export var lg = "_9u-6";
export var md = "_9u-5";
export var presenceDot = "_9u-b";
export var red = "_9u-d";
export var sm = "_9u-4";
export var status = "_9u-a";
export var typingDot = "_9u-h";
export var typingPill = "_9u-g";
export var xl = "_9u-7";
export var xs = "_9u-3";
export var xxl = "_9u-8";
export var xxs = "_9u-2";
export var yellow = "_9u-e";